import styled from 'styled-components';
import { forTablet, forDesktop } from '@westwing/ui-kit/breakPoints';
import GenericHeading from '@ids/components/Typography/Heading';
import Text from '@ids/components/Typography/Text';
import { scrollMarginToSection } from '@ids/components/Layout/utils';

export const PriceTiersSection = styled.section`
    --section-x-space-mobile: 20px;

    ${scrollMarginToSection}
`;

export const Header = styled.header`
    padding: 0 var(--section-x-space-mobile) 10px;
`;

export const Heading = styled(GenericHeading)`
    text-align: center;
    margin-bottom: 10px;
`;

export const Description = styled(Text)`
    text-align: center;
    margin-bottom: 20px;

    ${forTablet`
        margin-bottom: 32px;
    `}

    ${forDesktop`
    margin-bottom: 40px;
    `}
`;

export const Body = styled.div`
    background: ${({ theme }) => theme.colors.charcoal3};
    width: 100%;
    padding: var(--section-x-space-mobile);
    margin-bottom: 20px;

    ${forTablet`
        background: none;
        margin-bottom: 48px;
    `}

    ${forDesktop`
        padding: 0;
    `}
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: center;
`;
